module.exports = __webpack_public_path__ + "img/selected6-min.c36449c6.png";